import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = ({ currentLanguage }) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqData = [
    {
      id: 1,
      question: currentLanguage === 'en' ?'How much does an initial consultation cost?' :'Mazungumzo ya kwanza yagharimu kiasi gani?',
      answer: currentLanguage === 'en'
        ? `Our initial consultation is free for the first 30 minutes. This allows us to understand your legal matter and provide you with an overview of our services. If you decide to proceed, we'll discuss our fee structure which varies depending on the complexity and type of legal matter.`
        : `Mazungumzo yetu ya kwanza ni bure kwa dakika 30 za kwanza. Hii inaturuhusu kuelewa jambo lako la kisheria na kukupa muhtasari wa huduma zetu. Ukiamua kuendelea, tutajadili muundo wetu wa ada ambao hutofautiana kulingana na ugumu na aina ya jambo la kisheria.`
    },
    {
      id: 2,
      question: currentLanguage === 'en'? 'What documents should I bring to my consultation?': 'Ni nyaraka zipi ninapaswa kuleta katika mazungumzo yangu?',
      answer: currentLanguage === 'en'
        ? `Please bring any relevant documents related to your legal matter, including contracts, correspondence, court documents, identification, and any other paperwork that might be relevant. If you're unsure what to bring, we can discuss this when you schedule your appointment.`
        : `Tafadhali leta nyaraka zozote zinazohusiana na jambo lako la kisheria, ikiwa ni pamoja na mikataba, mawasiliano, nyaraka za mahakama, kitambulisho, na nyaraka zingine zozote ambazo zinaweza kuwa muhimu. Usiwe na uhakika wa kile cha kuleta, tunaweza kujadili hili unapopanga miadi yako.`
    },
    {
      id: 3,
      question: currentLanguage === 'en' ?'How quickly can you respond to urgent legal matters?' :'Ni kwa kasi gani mnaweza kujibu mambo ya haraka ya kisheria?',
      answer: currentLanguage === 'en' ? `For urgent legal matters, we strive to respond within 2-4 hours during business hours. For after-hours emergencies, please call our emergency line or send a WhatsApp message marked "URGENT". We understand that legal emergencies can't wait and we're committed to providing timely assistance.` : `Kwa mambo ya haraka ya kisheria, tunajitahidi kujibu ndani ya masaa 2-4 wakati wa kazi. Kwa dharura za baada ya masaa ya kazi, tafadhali piga simu yetu ya dharura au tuma ujumbe wa WhatsApp ulioandikwa"DHARURA". Tunaelewa kuwa dharura za kisheria haziwezi kusubiri na tumejitolea kutoa msaada wa wakati.`
    },
    {
      id: 4,
      question: currentLanguage === 'en' ?'Do you handle cases outside of Nairobi?' :'Je, mnashughulikia kesi nje ya Nairobi?',
      answer: currentLanguage === 'en'
        ? `Yes, we handle cases throughout Kenya. While our main office is in Nairobi, we have experience representing clients in various counties across the country. We can arrange to meet clients at convenient locations or handle matters remotely when appropriate.`
        : `Ndiyo, tunashughulikia kesi katika Kenya nzima. Ingawa ofisi yetu kuu iko Nairobi, tuna uzoefu wa kuwakilisha wateja katika kaunti mbalimbali nchini. Tunaweza kupanga kukutana na wateja katika maeneo yanayofaa au kushughulikia mambo kwa mbali inapofaa.`
    },
    {
      id: 5,
      question: currentLanguage === 'en' ?'What payment methods do you accept?' :'Ni njia zipi za malipo mnazokubali?',
      answer: currentLanguage === 'en'
        ? `We accept various payment methods including bank transfers, mobile money (M-Pesa), cash payments, and checks. We also offer flexible payment arrangements for certain cases. Payment terms will be clearly outlined in our engagement letter before we begin work on your matter.`
        : `Tunakubali njia mbalimbali za malipo ikiwa ni pamoja na uhamisho wa benki, pesa za simu (M-Pesa), malipo ya fedha taslimu, na hundi. Pia tunatoa mipango ya malipo ya kubadilika kwa kesi fulani. Masharti ya malipo yataainishwa wazi katika barua yetu ya ushirikiano kabla hatujaanza kazi kwenye jambo lako.`
    },
    {
      id: 6,
      question: currentLanguage === 'en' ?'How do you ensure client confidentiality?' :'Je, mnahakikishaje usiri wa mteja?',
      answer: currentLanguage === 'en'
        ? `Client confidentiality is paramount to our practice. We are bound by attorney-client privilege and professional ethics rules. All communications, documents, and information shared with us are kept strictly confidential. Our office has secure systems in place to protect client information and we never discuss client matters with unauthorized parties.`
        : `Usiri wa mteja ni muhimu sana katika utendaji wetu. Tunafungwa na haki ya mwanasheria-mteja na kanuni za maadili ya kitaaluma. Mawasiliano yote, nyaraka, na taarifa zinazoshirikiwa nasi zinawekwa kwa usiri mkuu. Ofisi yetu ina mifumo salama ya kulinda taarifa za wateja na hatujadili kamwe mambo ya wateja na wahusika wasioruhusiwa.`
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg border border-border p-6 lg:p-8">
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-text-primary mb-2">
          {currentLanguage === 'en' ? 'Frequently Asked Questions' : 'Maswali Yanayoulizwa Mara kwa Mara'}
        </h3>
        <p className="text-text-secondary">
          {currentLanguage === 'en' ?'Find answers to common questions about our legal services and consultation process.' :'Pata majibu ya maswali ya kawaida kuhusu huduma zetu za kisheria na mchakato wa mazungumzo.'
          }
        </p>
      </div>

      <div className="space-y-4">
        {faqData.map((faq) => (
          <div key={faq.id} className="border border-border rounded-lg overflow-hidden">
            <button
              onClick={() => toggleFAQ(faq.id)}
              className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-surface/10 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset"
            >
              <span className="font-medium text-text-primary pr-4">{faq.question}</span>
              <Icon 
                name="ChevronDown" 
                size={20} 
                className={`flex-shrink-0 transition-transform duration-200 ${
                  openFAQ === faq.id ? 'rotate-180' : ''
                }`}
              />
            </button>
            
            {openFAQ === faq.id && (
              <div className="px-6 pb-4 border-t border-border">
                <div className="pt-4">
                  <p className="text-text-secondary leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Additional Help */}
      <div className="mt-8 p-4 bg-surface/10 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="HelpCircle" size={20} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="font-medium text-text-primary mb-1">
              {currentLanguage === 'en' ? 'Still have questions?' : 'Bado una maswali?'}
            </h4>
            <p className="text-text-secondary text-sm">
              {currentLanguage === 'en' ?'If you couldn\'t find the answer you\'re looking for, please don\'t hesitate to contact us directly. We\'re here to help!'
                : 'Ikiwa hukupata jibu unalolitafuta, tafadhali usisite kutuwasiliana moja kwa moja. Tuko hapa kusaidia!'
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;